import React, { useState } from 'react';
import './App.css';

function SalaryCalculator(props) {
  const [salaryInputValue, setSalaryInputValue] = useState('');
  const [hoursDropdownValue, setHoursDropdownValue] = useState('');
  const [result, setResult] = useState(null);

  const handleInputChange = (event) => {
    setSalaryInputValue(event.target.value);
  };

  const handleDropdownChange = (event) => {
    setHoursDropdownValue(event.target.value);
  };
  
  const handleCalculate = () => {
    const salary = parseFloat(salaryInputValue.replace(/[^0-9.-]+/g,"")); // Remove non-numeric characters
    const hours = parseFloat(hoursDropdownValue);
    
    if (!isNaN(salary) && !isNaN(hours)) {
      const calculatedResult = (((salary/24)/30) * hours) * 24;
      calculatedResult.toFixed(2);// Round to 2 decimal places
      setResult(calculatedResult.toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
    } else {
      setResult('Invalid input');
    }
  };

  return (
    <>
        <div>
            <label htmlFor="userInput" className='modal-input-label'>Salary listed in row {props.row?.replace(/<[^>]*>/g, ' ')}, column {props.column?.replace(/<[^>]*>/g, ' ')}:</label>
            <input type="text" id="userInput" className='input dollar-sign' value={salaryInputValue} onChange={handleInputChange} placeholder=""
            />
        </div>
        <div>
            <label htmlFor="userDropdown" className='modal-input-label'>Hours worked per week:</label>
            <select id="userDropdown" className='dropdown' value={hoursDropdownValue} onChange={handleDropdownChange}required>
                <option value="" className='disabled' selected disabled>Select</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
            </select>
        </div>
        {result !== null && (
            <div>
                <p className='sub-title'>Result: {result}</p>
            </div>
        )}
        <div>
            <button onClick={handleCalculate} className="default-button next-button">Convert</button>
        </div>
    </>
  );
}

export default SalaryCalculator;